import {
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';

import { LanguageService } from '../../i18n/language.service';
import { Language } from '../../i18n/translation.types';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.html',
  styleUrl: './language-switcher.scss',
})
export class LanguageSwitcher {
  readonly i18n = inject(LanguageService);

  @ViewChild('languageMenu')
  private readonly languageMenu?: ElementRef<HTMLDetailsElement>;

  setLanguage(language: Language): void {
    this.i18n.setLanguage(language);

    if (this.languageMenu) {
      this.languageMenu.nativeElement.open = false;
    }
  }
}
